////
/// ============================================================================
/// COMPONENT / Header
/// ============================================================================
///
/// @group components
////

import Headroom from "headroom.js";

export default () => {

    /**
     * Header Stick
     *
     * @link https://github.com/WickyNilliams/headroom.js
     */
    const header = document.querySelector(".js-header");

    if (!header) {
        return;
    }

    const headroom = new Headroom(header, {
        offset: 0,
        tolerance: 0,
        classes: {
            initial: 'header',
            pinned: 'header--pinned',
            unpinned: 'header--unpinned',
            top : 'header--top',
            notTop : 'header--not-top',
            bottom : 'header--bottom',
            notBottom : 'header--not-bottom'
        }
    });

    headroom.init();

    /**
     * Navigation
     *
     * @summary Priority Navigation
     * @link http://codepen.io/lukejacksonn/pen/BowbWE
     */
    (function () {
        let navToggle = $('.menu-toggle');
        let navMenu = $('.menu');
        let navHidden = $('.menu-hidden');
        let numOfItems = 0;
        let totalSpace = 0;
        let breakWidths = [];

        // Get initial state
        navMenu.children().outerWidth(function(i, w) {
            totalSpace += w;
            numOfItems += 1;
            breakWidths.push(totalSpace);
        });

        var availableSpace, numOfVisibleItems, requiredSpace;

        function check() {
            navMenu.addClass('menu--active');

            // Get instant state
            availableSpace = navMenu.width() - 0;
            numOfVisibleItems = navMenu.children().length;
            requiredSpace = breakWidths[numOfVisibleItems - 1];

            // There is not enought space
            if (requiredSpace > availableSpace) {
                navMenu.addClass('menu--priority');
                navMenu.children().last().prependTo(navHidden);
                numOfVisibleItems -= 1;
                check();
                // There is more than enough space
            } else if (availableSpace > breakWidths[numOfVisibleItems]) {
                navMenu.removeClass('menu--priority');
                navHidden.children().first().appendTo(navMenu);
                numOfVisibleItems += 1;
            }
            // Update the button accordingly
            navToggle.attr('count', numOfItems - numOfVisibleItems);
            if (numOfVisibleItems === numOfItems) {
                navToggle.addClass('hidden');
            } else {
                navToggle.removeClass('hidden');
            }
        }

        // Window listeners
        $(window).resize(function() {
            check();
        });

        navToggle.on('click', function() {
            navHidden.toggleClass('hidden');
        });

        check();
    }());

};
